import React from "react";
import Office from "../../../../assets/svg/office365.svg";
import excelicon from "../../../../assets/svg/btn_icons/export-excel-icon.svg";

function ExcelExport({ handleExcelExport,label,className }) {
  return (
    <button
      type="button"
      className={`btn btn-soft-gray button-btn-label button-lg ${className}`}
      style={{ width: "max-content" }}
      onClick={handleExcelExport}
    >
      <img src={excelicon} alt="" className="export-btn-img" />
      <span>{label?.toUpperCase() || "EXPORT TO EXCEL"}</span>
    </button>
  );
}

export default ExcelExport;
